import 'codemirror/keymap/sublime'
